export default {
  invoice (state) {
    return state.invoice
  }
}
